import React, { useState, useRef, useEffect } from 'react'
import { Paper, Grid, Button } from '@material-ui/core'
import DataComponent from 'EurestoComponents/DataComponents'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import User from 'EurestoClass/User'
import Data from 'EurestoClass/Data'
import ApiRequest from 'EurestoApi/ApiRequest'
import Input from 'Components/Input'
import Select from 'Components/Select'
import InputSearch from 'EurestoComponents/InputSearch'
import Modal from 'Components/Modal'
import Fiche from './Fiche'
import EurestoTable from 'Components/EurestoTable'
import project from 'EurestoConfig/project.config'

const columns = [
    {
        header: 'id',
        accessor: 'id',
        show: false
    }, {
        header: EurestoI18n.t('crm:Produit'),
        headerClassName: 'EurestoPrimary EurestoText--text',
        id: 'produit_libelle',
        filters: ['search'],
        type: 'string',
        maxWidth: 150,
    }, {
        header: EurestoI18n.t('crm:Quantite'),
        id: 'quantite',
        filters: ['search'],
        type: 'string',
        sortable: true,
        accessor: 'quantite',
        Cell: row => <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
            alignItems={'center'} direction={'column'}>
            {row.quantite}
        </Grid>
    }, {
        header: EurestoI18n.t('crm:Unité'),
        id: 'libelle_unite_stockage',
        filters: ['search'],
        type: 'string',
        sortable: true,
        accessor: 'libelle_unite_stockage',
        Cell: row => <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
            alignItems={'center'} direction={'column'}>
            {row.libelle_unite_stockage}
        </Grid>
    }, {
        header: EurestoI18n.t('crm:P.U HT'),
        id: 'prix',
        filters: ['search'],
        type: 'string',
        sortable: true,
        accessor: 'prix'
    }, {
        header: EurestoI18n.t('crm:TVA'),
        id: 'montant_tva',
        filters: ['search'],
        type: 'string',
        sortable: true,
        accessor: 'montant_tva',
        Cell: row => <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
            alignItems={'center'} direction={'column'}>
            {row.montant_tva}( {row.produit_taux_tva} %)
        </Grid>
    }, {
        header: EurestoI18n.t('crm:Total TTC'),
        id: 'total_ttc',
        filters: ['search'],
        type: 'string',
        sortable: true,
        accessor: 'total_ttc'
    }, {
        header: EurestoI18n.t('crm:Modifiée le'),
        id: 'date_modification',
        maxWidth: 80,
        type: 'date',
        accessor: 'date_modification',
        format: 'DD/MM/YY',
    }
]

export default React.memo(props => {
    console.log(props)
    const produit = useRef({})
    const [key, setKey] = useState(Utils.uuidv4())
    const [produits, setProduits] = useState([])
    const [resetInput, setResetInput] = useState(Utils.uuidv4())
    const [details, setDetails] = useState(props.document.details || [])
    const [showModalLigneDetail, setShowModalLigneDetail] = useState(false)
    const [saisiePrix, setSaisiePrix] = useState(false)

    useEffect(() => {
        window.addEventListener('mouseup', function (event) {
            event.stopPropagation()
            if (!event || !event.target || (event.target.className.indexOf('MyPaperParentToNotCloseIfClicked') === -1
                && !Utils.findparentClass(event.target.parentNode, 'MyPaperParentToNotCloseIfClicked'))) {
                //setShowModalLigneDetail(false)
            }
        });
    }, [])

    const onSaveForm = () => {
        setDetails([
            ...details,
            produit.current
        ])
        props.onChange && props.onChange(details, props.name || "details")
        setShowModalLigneDetail(false)
    }

    const onCancelform = () => {
        produit.current = {}
        setShowModalLigneDetail(false)
    }

    const getProduit = async search => {
        search = {
            libelle: search.libelle,
            famille_id: search.famille_id,
            rubrique_id: search.rubrique_id,
        }
        return await ApiRequest(project.api + 'gestion', {
            requete: 'produit',
            action: 'list',
            limit: 5,
            offset: 0,
            recherche: Utils.searchJsonToRechercheArray(search)
        })
    }



    const searchProduit = async (data, name) => {
        produit.current[name] = data
        const produits = await getProduit(produit.current)

        if (produit.current.produit_id && !produits.find(p => p.id === produit.current.produit_id)) {
            produit.current.type_tva_id = undefined
            produit.current.libelle_unite_stockage = undefined
            produit.current.media_id = undefined
            produit.current.media_lien = undefined
            produit.current.rubrique_id = undefined
            produit.current.famille_id = undefined
            produit.current.produit_libelle = undefined
            produit.current.code_barre = undefined

            produit.current[name] = data
        }

        setProduits(produits && produits.results || [])
    }

    const onChangeForm = (data, name, o) => {
        console.log(data, name, o)
        if (name === 'mouvement_id') {
            const mouvement = Data.list(Constants.module.GESTION, Constants.donnee.type_mouvement, { id: data })
            if (mouvement) {
                setSaisiePrix(mouvement.saisie_prix)
            }
        } else if (name === 'quantite') {
            // const tva = Data.list(Constants.module.COMMUN, Constants.donnee.taux_tva, { id: produit.current.type_tva_id })
            // produit.current.montant_tva
            if (produit.current.prix) {
                produit.current.prix_total = parseFloat(produit.current.prix) * parseFloat(data)
                produit.current.montant_tva = parseFloat(produit.current.prix_tva) * parseFloat(data)
                produit.current.total_ttc = parseFloat(produit.current.prix_ttc) * parseFloat(data)
            }
            setKey(Utils.uuidv4())
        } else if (name === 'prix') {
            // const tva = Data.list(Constants.module.COMMUN, Constants.donnee.taux_tva, { id: produit.current.type_tva_id })
            // produit.current.montant_tva
            produit.current.prix_tva = (parseFloat(produit.current.produit_taux_tva) * parseFloat(data)) / 100
            produit.current.prix_ttc = parseFloat(data) + parseFloat(produit.current.prix_tva)
            if (produit.current.quantite) {
                produit.current.prix_total = parseFloat(produit.current.quantite) * parseFloat(data)
                produit.current.montant_tva = parseFloat(produit.current.prix_tva) * parseFloat(produit.current.quantite)
                produit.current.total_ttc = parseFloat(produit.current.prix_ttc) * parseFloat(produit.current.quantite)
            }
            setKey(Utils.uuidv4())
        } else if (name === 'produit_id') {
            const po = produits.find(p => p.id === data)
            console.log(po)
            produit.current.type_tva_id = po.type_tva_id
            produit.current.libelle_unite_stockage = po.libelle_unite_stockage
            produit.current.produit_taux_tva = po.produit_taux_tva
            produit.current.unite_id = po.unite_id
            produit.current.media_id = po.media_id
            produit.current.media_lien = po.media_lien
            produit.current.rubrique_id = po.rubrique_id
            produit.current.famille_id = po.famille_id
            produit.current.produit_libelle = po.libelle
            produit.current.code_barre = po.code_barre
            setKey(Utils.uuidv4())
        }
        produit.current[name] = data


        props.onChange && props.onChange(details, props.name || "details")
    }

    const onView = (row, index) => {
        produit.current = row
        if (produit.current.mouvement_id) {
            const mouvement = Data.list(Constants.module.GESTION, Constants.donnee.type_mouvement, { id: produit.current.mouvement_id })
            if (mouvement) {
                setSaisiePrix(mouvement.saisie_prix)
            }
        }
        setShowModalLigneDetail(true)
    }

    const openModalAdd = () => {
        produit.current = {
            mouvement_id: props.document.mouvement_id
        }
        if (props.document.mouvement_id) {
            const mouvement = Data.list(Constants.module.GESTION, Constants.donnee.type_mouvement, { id: props.document.mouvement_id })
            if (mouvement) {
                setSaisiePrix(mouvement.saisie_prix)
            }
        }
        setShowModalLigneDetail(true)
    }

    console.log(produit.current)

    return <Grid key={key} container spacing={0} style={{ padding: 10, margin: 0, position: 'relative', height: '100%', maxHeight: '100%', }}>
        <Paper style={{
            cursor: 'pointer', position: 'relative', height: '100%', maxHeight: '100%', width: '100%',
            background: 'white'
        }}>
            <EurestoTable
                columns={columns}
                maxHeight={'100%'}
                style={{
                    maxHeight: '100%',
                }}
                styleRow={(row) => !row.valide && { border: '1px solid ' + EurestoColor('EurestoError'), color: EurestoColor("EurestoPrimary") } || {}}
                onClick={onView}
                datas={details} />

            <Button
                variant={'contained'}
                size="small"
                onClick={openModalAdd}
                style={{
                    border: `1px solid ${EurestoColor('primary')}`,
                    position: 'absolute', right: 10, bottom: 10, fontSize: 20, padding: "0px 10px", fontWeight: 'bold',
                    ...(showModalLigneDetail && { filter: 'blur(2px)' } || {}),
                }}
                className={`EurestoText EurestoSecondary--text`}
                disabled={false}>
                +
            </Button>
            {showModalLigneDetail && <React.Fragment>
                <Grid container direction={'column'} alignContent={'center'} justify={'center'} spacing={0}
                    style={{ padding: 0, margin: 0, position: 'absolute', height: '100%', maxHeight: '100%', top: 0, backgroundColor: 'black', opacity: .65 }}>
                </Grid>
                <Grid container direction={'column'} alignContent={'center'} justify={'center'} spacing={0}
                    style={{ padding: 0, margin: 0, position: 'absolute', height: '100%', maxHeight: '100%', top: 0 }}>
                    <Paper className={'MyPaperParentToNotCloseIfClicked'} style={{
                        cursor: 'pointer', position: 'relative', width: '33%', background: 'white'
                    }}>
                        <Grid spacing={0} container style={{ padding: "10px 10px 2.5px 10px", margin: 0 }} direction={'column'}>

                            <Paper style={{ marginBottom: 5 }}>
                                <Grid container justify={'flex-start'} alignItems={'center'} spacing={0}>
                                    <Grid item style={{ padding: 5 }}>
                                        <Grid container style={{ position: 'relative' }} direction={'column'} justify={'flex-start'}
                                            alignItems={'center'} spacing={0}>
                                            {/* {produit.current && produit.current.produit_id && <Fab className={'EurestoSecondary--text EurestoPrimary'}
                                                size={'small'}
                                                onClick={this.handleToggleModalContact(true)}
                                                style={{ top: -5, left: -5, position: 'absolute' }}>
                                                <i className={'ei-commun_user_2'}
                                                    style={{ fontSize: 16 }} />
                                            </Fab>} */}
                                            <DataComponent onChange={searchProduit}
                                                name='picture'
                                                avatarStyle={{
                                                    borderRadius: 10,
                                                    maxWidth: 100,
                                                    maxHeight: 100
                                                }}
                                                style={{
                                                    height: 100
                                                }}
                                                disabled={props.disabled}
                                                type={Constants.typeSaisie.Picture}
                                                defineData
                                                data={{
                                                    id: produit.current.media_id,
                                                    lien: produit.current.media_lien
                                                }}
                                                object={{
                                                    picture: {
                                                        id: produit.current.media_id,
                                                        lien: produit.current.media_lien
                                                    },
                                                    type: 'produit'
                                                }} />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs style={{ padding: 5 }}>
                                        <Grid container spacing={8} justify={'flex-start'}>
                                            <Grid item sm={12} md={12} style={{ paddingRight: 5 }}>
                                                <DataComponent disabled={props.disabled}
                                                    inline
                                                    onChange={searchProduit}
                                                    title={EurestoI18n.t('crm:Famille')}
                                                    key={key + produit.current.famille_id + '_famille_id'}
                                                    name="famille_id"
                                                    data={produit.current.famille_id}
                                                    type={Constants.typeSaisie.ComboSimple}
                                                    object={Constants.donnee.famille}
                                                    module={Constants.module.GESTION}
                                                    search={{ type: 1 }}
                                                />
                                            </Grid>
                                            <Grid item sm={12} md={12} style={{ paddingRight: 5 }}>
                                                <DataComponent disabled={props.disabled}
                                                    inline
                                                    onChange={searchProduit}
                                                    title={EurestoI18n.t('crm:Rubrique')}
                                                    key={key + produit.current.rubrique_id + '_rubrique'}
                                                    name="rubrique_id"
                                                    data={produit.current.rubrique_id}
                                                    type={Constants.typeSaisie.ComboSimple}
                                                    object={Constants.donnee.rubrique}
                                                    module={Constants.module.GESTION}
                                                    search={{ type: 1 }}
                                                />
                                            </Grid>
                                            <Grid item sm={12} md={12} style={{ paddingRight: 5 }}>
                                                <Select disabled={props.disabled}
                                                    inline
                                                    title={'Nom'}
                                                    onChangeText={searchProduit}
                                                    key={key + produit.current.produit_id + '_libelle'}
                                                    options={(produits || []).map(p => ({
                                                        label: p.libelle,
                                                        value: p.id,
                                                        html: <span><strong>{p.libelle}</strong></span>
                                                    }))}
                                                    onChange={onChangeForm}
                                                    name={'produit_id'}
                                                    nameText={'libelle'}
                                                    text={produit.current.produit_libelle}
                                                    value={produit.current.produit_id}
                                                />
                                            </Grid>
                                            <Grid item sm={12} md={12} style={{ paddingRight: 5 }}>
                                                <Input disabled={props.disabled}
                                                    inline
                                                    title={'Code barre'}
                                                    key={key + produit.current.code_barre + '_code_barre'}
                                                    onChange={searchProduit}
                                                    name={'code_barre'}
                                                    value={produit.current.code_barre}
                                                />
                                            </Grid>
                                            <Grid item sm={12} md={12} style={{ paddingRight: 5 }}>
                                                <DataComponent
                                                    inline
                                                    onChange={onChangeForm}
                                                    title={EurestoI18n.t('commun:Taux TVA')}
                                                    name="type_tva_id"
                                                    disabled={props.disabled}
                                                    type={Constants.typeSaisie.ComboSimple}
                                                    data={produit.current.type_tva_id}
                                                    object={Constants.donnee.taux_tva}
                                                    module={Constants.module.GESTION}
                                                    search={{ region_id: User.Entite.get().type === Constants.access.ETABLISSEMENT ? User.Entite.get().region_tva_id || 1 : 1 }} />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Paper>
                            {/* <InputSearch
                                inline
                                title={EurestoI18n.t('gestion:Produit')}
                                classNameModal={"MyPaperParentToNotCloseIfClicked"}
                                menuMaxHeight={196}
                                placeholder={EurestoI18n.t('commun:Insérer un produit, une étape ou un commentaire')}
                                disabled={props.disabled}
                                MenuProps={{
                                    style: { width: 300 }
                                }}
                                recherche={{
                                    type_produit_id: [1, 2, 3, 4],
                                }}
                                style={{ marginBottom: 0 }}
                                value={produit.current.produit_id}
                                limit={15}
                                name={'produit_id'}
                                onChange={onChangeForm} path={'gestion'} requete={'produit'} search={'libelle'}
                                id={'id'}
                                resetInput={resetInput} /> */}
                            <DataComponent
                                onChange={onChangeForm}
                                title={EurestoI18n.t('commun:Mouvement')}
                                name="mouvement_id"
                                disabled={props.disabled}
                                columnOptions={'abrege'}
                                type={Constants.typeSaisie.ComboSimple}
                                search={props.document && { type: { in: Constants.typeMouvementStock[props.document.type] } }}
                                data={produit.current.mouvement_id}
                                object={Constants.donnee.type_mouvement}
                                module={Constants.module.GESTION}
                            />
                            <Input onChange={onChangeForm} name={"quantite"} disabled={props.disabled} value={produit.current.quantite} inline title={EurestoI18n.t('commun:Quantité')} />

                            <DataComponent
                                onChange={onChangeForm}
                                title={EurestoI18n.t('commun:Unité')}
                                key={key + produit.current.produit_id + '_unite_produit'}
                                name="unite_id"
                                disabled={props.disabled}
                                columnOptions={'libelle'}
                                type={Constants.typeSaisie.ComboSimple}
                                data={produit.current.unite_id}
                                object={Constants.donnee.unite}
                                module={Constants.module.GESTION}
                            />
                            {saisiePrix !== 0 &&
                                <Grid container spacing={0} justify={'flex-start'}>
                                    <Grid item sm={6} md={6} style={{ paddingRight: 5 }}>
                                        <Grid container style={{ position: 'relative' }} direction={'column'} justify={'flex-start'}
                                            alignItems={'center'} spacing={0}>
                                            <Input type='number' onChange={onChangeForm} name={"prix"} disabled={props.disabled} value={produit.current.prix} title={EurestoI18n.t('commun:PU HT')} />
                                            <Input type='number' onChange={onChangeForm} name={"prix_tva"} disabled={props.disabled} value={produit.current.prix_tva} title={EurestoI18n.t('commun:PU TVA')} />
                                            <Input type='number' onChange={onChangeForm} name={"prix_ttc"} disabled={props.disabled} value={produit.current.prix_ttc} title={EurestoI18n.t('commun:PU TTC')} />
                                        </Grid>
                                    </Grid>
                                    <Grid item sm={6} md={6} style={{ paddingRight: 5 }}>
                                        <Grid container style={{ position: 'relative' }} direction={'column'} justify={'flex-start'}
                                            alignItems={'center'} spacing={0}>
                                            <Input type='number' onChange={onChangeForm} name={"prix_total"} disabled={props.disabled} value={produit.current.prix_total} title={EurestoI18n.t('commun:Total HT')} />
                                            <Input type='number' onChange={onChangeForm} name={"montant_tva"} disabled={props.disabled} value={produit.current.montant_tva} title={EurestoI18n.t('commun:Total TVA')} />
                                            <Input type='number' onChange={onChangeForm} name={"total_ttc"} disabled={props.disabled} value={produit.current.total_ttc} title={EurestoI18n.t('commun:Total TTC')} />
                                        </Grid>
                                    </Grid>
                                </Grid>}
                        </Grid>

                        <Grid spacing={0} container spacing={8} style={{ padding: "0px 10px 10px 10px", margin: 0 }} justify={'flex-end'}>
                            <Button
                                variant={'contained'}
                                size="small"
                                onClick={onCancelform}
                                style={{
                                    border: `1px solid ${EurestoColor('primary')}`,
                                    ontWeight: 'bold',
                                    padding: '0px 10px'
                                }}
                                className={`EurestoError EurestoText--text`}
                                disabled={props.disabled}>
                                Annuler
                            </Button><Button
                                variant={'contained'}
                                size="small"
                                onClick={onSaveForm}
                                style={{
                                    border: `1px solid ${EurestoColor('primary')}`,
                                    ontWeight: 'bold',
                                    padding: '0px 10px'
                                }}
                                className={`EurestoText EurestoSecondary--text`}
                                disabled={props.disabled}>
                                Enregistrer
                            </Button>
                        </Grid>
                    </Paper>
                </Grid>
            </React.Fragment>}
        </Paper>
    </Grid >
})


// WEBPACK FOOTER //
// ./app/App/Module/Stock/Component/Detail/index.js